import { useCallback } from 'react';
import get from 'lodash/get';
import { useMutation } from '@apollo/client/react';
import { formatGraphqlErrors } from 'utils/helpers';
import { Enable2FADocument, MeDocument } from 'graphql/generated/graphql';

const useEnable2FA = () => {
  const [enable2FA] = useMutation(Enable2FADocument);

  const handleActivate = useCallback(
    async ({ otp }: { otp: string }) => {
      try {
        const data = await enable2FA({
          variables: { otp },
          refetchQueries: [MeDocument],
          awaitRefetchQueries: true,
        });
        const isSuccess = get(data, 'data.enable2FA', null);
        return isSuccess;
      } catch (error) {
        throw formatGraphqlErrors(error);
      }
    },
    [enable2FA],
  );
  return handleActivate;
};

export default useEnable2FA;
